import { render, staticRenderFns } from "./image-content.vue?vue&type=template&id=57e05c49"
import script from "./image-content.vue?vue&type=script&lang=js"
export * from "./image-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports